import React from 'react';

const EmptyState: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-gray-50 font-sans p-6 md:p-10 flex items-center justify-center">
            <div className="text-center">
                <p className="text-xl text-gray-400">No template data available</p>
            </div>
        </div>
    );
};

export default EmptyState;
